import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { useState } from 'react'

import * as styles from './USAWaitingList.module.scss'
import { SUBSCRIBE_WAITING_LIST } from '../../constants/facebookPixel'
import {
  WAITING_LIST_ENDPOINT,
  WAITING_LIST_MESSAGE,
} from '../../constants/waitingList'
import { facebookPixelCustomEvent } from '../../services/facebook-pixel'
import Container from '../container/Container'
import SendEmailForm from '../custom/send-email-form/SendEmailForm'

function USAWaitingList({ className }) {
  const [submitedState, setSubmitedState] = useState(false)

  const handleSuccesfullSubscribe = () => {
    setSubmitedState(true)

    facebookPixelCustomEvent(SUBSCRIBE_WAITING_LIST)
  }

  return (
    <section className={classNames(styles.section, className)}>
      <Container fluid>
        {submitedState ? (
          <p className={styles.message}>{WAITING_LIST_MESSAGE}</p>
        ) : (
          <>
            <h2 className={styles.title}>Bamboo arrives soon in the USA</h2>
            <p className={styles.subheading}>Join the waitlist</p>
            <SendEmailForm
              id="US_waitinglist_form"
              className={styles.form}
              URL={WAITING_LIST_ENDPOINT}
              buttonContent="Keep me posted"
              inputId="usa_waiting_list_email"
              label="email"
              onUserSuccesfullySubmited={handleSuccesfullSubscribe}
            />
          </>
        )}
      </Container>
    </section>
  )
}

USAWaitingList.propTypes = {
  className: PropTypes.string,
}

export default USAWaitingList
